module.exports = __webpack_public_path__ + "img/bg.33a3b25c.jpg";